import { AppRef } from 'pbts/c1/api/app/v1/app'
import { CountAppUsersByAppsRequest, CountAppUsersByAppsResponse, AppAccountRollup } from 'pbts/c1/api/app/v1/app_user'
import { AppUserServiceClient } from 'pbts/c1/api/app/v1/app_user.client'
import { createMultiGetApi, MultiGetOpts } from './lib/createMultiGetApi'

const multiGetOpts: MultiGetOpts<AppRef, CountAppUsersByAppsRequest, CountAppUsersByAppsResponse, AppAccountRollup> = {
    buildRequest: (refs: AppRef[]) => ({
        appRefs: refs,
    }),
    transformResponse: (res: CountAppUsersByAppsResponse) => {
        return res.list
    },
    refExtractor: (item: AppAccountRollup) => {
        return { id: item.appId }
    },
    maxBatchSize: 100,
    tag: AppRef.typeName,
}

export const getAppUserCountApi = createMultiGetApi(
    AppUserServiceClient,
    'countAppUsersByApps',
    multiGetOpts,
)
